import React, { useState } from 'react';
import { FeatureFlags } from 'screens/FeatureFlags';
import { DeveloperButton } from './DeveloperToolsButton';
import { DeveloperToolsModal } from './DeveloperToolsModal';
import { SignUpTestUser } from './SignUpTestUser';

export const DeveloperTools = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [featureFlagsOpen, setFeatureFlagsOpen] = useState(false);
  const [signUpTestUserOpen, setSignUpTestUserOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleFeatureFlags = () => {
    handleCloseModal();
    setFeatureFlagsOpen(true);
  };

  const handleCloseFeatureFlags = () => {
    setFeatureFlagsOpen(false);
  };

  const handleSignUpTestUser = () => {
    handleCloseModal();
    setSignUpTestUserOpen(true);
  };

  const handleCloseSignUpTestUser = () => {
    setSignUpTestUserOpen(false);
  };

  return (
    <>
      <DeveloperButton onClick={handleOpenModal} />
      <DeveloperToolsModal
        open={modalOpen}
        onClose={handleCloseModal}
        onFeatureFlags={handleFeatureFlags}
        onSignUpTestUser={handleSignUpTestUser}
      />
      <FeatureFlags open={featureFlagsOpen} onClose={handleCloseFeatureFlags} />
      <SignUpTestUser open={signUpTestUserOpen} onClose={handleCloseSignUpTestUser} />
    </>
  );
};
